import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "dic_cookie_consent_v1";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShow(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-4 inset-x-4 z-[60] sm:left-auto sm:right-6 sm:max-w-md rounded-sm border border-brand-bordeaux/15 bg-brand-cream p-6 shadow-[0_20px_60px_-20px_rgba(24,24,24,0.4)]"
        >
          <p className="text-sm leading-relaxed text-brand-graphite/80">
            Utilizziamo cookie tecnici e, previo consenso, cookie di analytics e marketing. Puoi accettarli o
            rifiutare quelli non essenziali.{" "}
            <a href="/cookie" className="text-brand-bordeaux underline hover:text-brand-wine">
              Cookie Policy
            </a>
            .
          </p>
          <div className="mt-4 flex gap-3">
            <button
              onClick={() => decide("all")}
              data-testid="cookie-accept"
              className="flex-1 rounded-full bg-brand-bordeaux px-5 py-2.5 text-sm font-semibold text-brand-ivory hover:bg-brand-wine transition-colors"
            >
              Accetta
            </button>
            <button
              onClick={() => decide("essential")}
              data-testid="cookie-reject"
              className="flex-1 rounded-full border border-brand-bordeaux/25 px-5 py-2.5 text-sm font-semibold text-brand-bordeaux hover:bg-brand-ivory transition-colors"
            >
              Solo essenziali
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
